import React, { useEffect, useState } from "react";

import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Link,
  Typography,
} from "@mui/material";

import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { handlePagingAll } from "../../components/api/APIUtilities";
import { postNotification } from "../../components/utilities/Notifications";
import { BCPImageSlash } from "../../components/icons/bcp/BCPIcons";
import { getData } from "../../components/utilities/UtilityFunctions";

const fetchFile = async (fileId) => {
  if (!fileId) return;

  var returnObj;
  try {
    returnObj = await getData(`/files/${fileId}`, {
      queryStringParameters: {},
    });
  } catch (err) {
    console.error(err);
  }
  return returnObj;
};

const ImagePreview = (props) => {
  const { fileId, alt, outerSX } = props;
  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState(null);
  useEffect(() => {
    const go = async () => {
      setLoading(true);
      if (!fileId) {
        setImage(null);
        setLoading(false);
        return;
      }

      if (image) {
        if (image.id === fileId) {
          setLoading(false);
          return;
        }
        setImage(null);
      }

      try {
        var file = await fetchFile(fileId);
        if (file) {
          setImage({
            id: fileId,
            ...file,
          });
        }
      } catch (err) {
        //
      }
      setLoading(false);
    };

    go();
    // eslint-disable-next-line
  }, [fileId]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "50px",
        minHeight: "50px",
        maxHeight: "50px",
        p: 1,
        border: 1,
        borderColor: "divider",
        ...outerSX,
      }}
    >
      {!loading && image?.url && (
        <img
          src={image.url}
          alt={alt}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}
      {!loading && !image?.url && <BCPImageSlash />}
      {loading && <CircularProgress size={24} />}
    </Box>
  );
};

const fetchProducts = async (options) => {
  const { categorySlug, featured } = options;
  var queryStringParameters = {
    active: true,
  };
  if (categorySlug) {
    queryStringParameters.category = categorySlug;
  }
  if (featured) {
    queryStringParameters.featured = featured;
  }

  var returnArray = [];
  try {
    returnArray = await handlePagingAll(`/products`, queryStringParameters);
  } catch (err) {
    console.error(err);
    return undefined;
  }
  return returnArray;
};

export default function StoreIndex() {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState(null);
  const [categories, setCategories] = useState(null);

  const fetchCategories = async () => {
    var returnArray = [];
    try {
      returnArray = await handlePagingAll(`/productcategories`, {
        active: true,
      });
    } catch (err) {
      console.error(err);
      return undefined;
    }
    return returnArray;
  };

  async function parallel() {
    const taskFeatured = fetchProducts({
      featured: true,
    });
    const taskCategories = fetchCategories();

    return {
      featured: await taskFeatured,
      categories: await taskCategories,
    };
  }

  useEffect(() => {
    const go = async () => {
      try {
        var parallelData = await parallel();
        var apiProducts = parallelData.featured;
        var apiCategories = parallelData.categories;

        setProducts(apiProducts);
        setCategories(apiCategories);
      } catch (err) {
        postNotification("error", err);

        setLoading(false);
        return;
      }
      setLoading(false);
    };

    go();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid container sx={{ gap: 2 }}>
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
            }}
          >
            <Typography variant="h3">Shop</Typography>
           
          </Grid>

          {products?.length > 0 && (
            <Grid
              item
              xs={12}
              sx={{
                p: 2,
              }}
            >
              <Typography variant="h4">Featured</Typography>
              <Grid container spacing={2}>
                {products.map((product, index) => {
                  return (
                    <Grid item xs={12} sm={6} md={4}>
                      <ProductPreview key={index} product={product} />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          )}

          {categories?.length > 0 &&
            categories.map((category, index) => {
              return <CategorySection key={index} category={category} />;
            })}
        </Grid>
      </Container>
      {loading && <ModalLoadingFull />}
    </>
  );
}

const CategorySection = (props) => {
  const { category } = props;
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  useEffect(() => {
    const go = async () => {
      var apiPoducts = await fetchProducts({
        categorySlug: category?.slug,
      });
      setProducts(apiPoducts);
      setLoading(false);
    };
    go();
  }, [category]);
  if (loading || products?.length === 0) {
    return <></>;
  }
  return (
    <Grid
      item
      xs={12}
      sx={{
        p: 2,
      }}
    >
      <Typography variant="h4">{category?.name}</Typography>
      <Grid container spacing={2}>
        {products.map((product, index) => {
          return (
            <Grid item xs={12} sm={6} md={4}>
              <ProductPreview key={index} product={product} />
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

const ProductPreview = (props) => {
  const { product } = props;
  return (
    <Grid
      container
      spacing={1}
      sx={{
        mt: 2,
        p: 2,
      }}
      component={Link}
      underline="none"
      href={`/shop/product/${product?.id}`}
    >
      <Grid item xs={12}>
        <ImagePreview
          fileId={product?.imageFileId}
          alt={product?.name}
          outerSX={{
            width: "100%",
            minHeight: "unset",
            maxHeight: "unset",
            border: "unset",
            borderColor: "unset",
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h5">{product?.name}</Typography>

        {product?.loyaltyPoints !== undefined && (
          <Typography variant="body1">{product?.loyaltyPoints} LP</Typography>
        )}
      </Grid>
    </Grid>
  );
};
